import type { Component } from "solid-js";
import { untrack } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import { useModalManager } from "../../../components/modal/ModalManager";
import type WebhookId from "../../../state/WebhookId";
import ApiService from "../../../services/ApiService";
import GenericFailureModal from "../../GenericFailureModal";
import { DestructiveModal } from "../../../components/modal/Modal";

type DeleteWebhookModalProps = {
  webhookId: WebhookId;
  onConfirm?: () => void;
};
const DeleteWebhookModal: Component<DeleteWebhookModalProps> = (props) => {
  const { t } = useTranslation();
  const { replace } = useModalManager();

  return (
    <DestructiveModal
      title={t(($) => $.SETTINGS_WEBHOOKS_DELETE_MODAL_TITLE)}
      description={t(($) => $.SETTINGS_WEBHOOKS_DELETE_MODAL_DESCRIPTION)}
      confirmLabel={t(($) => $.SETTINGS_WEBHOOKS_DELETE_MODAL_ACTIONS_CONFIRM)}
      confirmLabelSlow={t(($) => $.SETTINGS_WEBHOOKS_DELETE_MODAL_ACTIONS_CONFIRM_SLOW)}
      cancelLabel={t(($) => $.SETTINGS_WEBHOOKS_DELETE_MODAL_ACTIONS_CANCEL)}
      onConfirm={() =>
        new Promise((resolve, reject) => {
          ApiService.deleteWebhook().mutate(
            untrack(() => props.webhookId),
            {
              onSuccess: () => {
                resolve();
                props.onConfirm?.();
              },
              onError: (err) => {
                replace({
                  content: () => <GenericFailureModal error={err} />,
                });
                reject(err);
              },
            },
          );
        })
      }
    />
  );
};

export default DeleteWebhookModal;
